import { CheckIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import React from "react";
import { Experience } from "types";
import { NoTranslate } from "../../Common/NoTranslate";
import { ProductImage } from "../../Common/ProductImage";

export const OverridingExperiencesList = ({ experiences }: { experiences: Experience[] }) => {
    return (
        <div className="flex flex-col space-y-3">
            <span className="font-bold">Products</span>
            <div className="rounded-md border border-gray-lighter">
                {experiences.map((experience: Experience) => (
                    <div
                        key={experience.id}
                        className="flex h-10 items-center border-b border-gray-lighter p-2 last:border-b-0"
                    >
                        <ProductImage product={experience} size="tiny" />
                        <NoTranslate>{experience.name}</NoTranslate>
                    </div>
                ))}
            </div>
        </div>
    );
};

export const NoOverrides = () => {
    return (
        <Alert color="primary">
            <span>
                <CheckIcon /> <span className="text-primary-darker">All products use the T&C configured here</span>
            </span>
        </Alert>
    );
};
